import content from '../../content.js'
import AppProductsSlideshow from '../app-products-slideshow'

export default
{
    components: {
        AppProductsSlideshow
    },

    data()
    {
        return {
            products: content.products,
            others: JSON.parse(JSON.stringify(content.products))
        }
    },

    methods:
    {

    }
}